import BaseService from './../base'

class recruitPosition extends BaseService {
    // 职位列表
    async jobList(postData) {
        return await this.get('/admin/job', postData);
    }
    // 新增职位
    async jobAdd(postData) {
        return await this.post('/admin/job', postData);
    }
    // 删除职位
    async jobDelete(id) {
        return await this.delete(`/admin/job/${id}`);
    }
    // 修改职位
    async jobUpdata(id, postData) {
        return await this.patch(`/admin/job/${id}`, postData);
    }
    // 根据ID查询职位
    async jobDetails(id) {
        return await this.get(`/admin/job/${id}`);
    }
    // 修改职位状态
    async changeJobState(id, postData) {
        return await this.patch(`/admin/job/change_status/${id}`, postData);
    }
    // 擦亮职位
    async changeJobTime(id, postData) {
        return await this.patch(`/admin/job/change_time/${id}`, postData);
    }
    // 修改职位置顶状态
    async changeJobTop(id) {
        return await this.patch(`/admin/job/is_top/${id}`);
    }
}

export default new recruitPosition();